// extracted by mini-css-extract-plugin
export var blockedMessage = "_bi-3";
export var blockedOverlay = "_bi-1";
export var fadeIn = "_bi-2";
export var hereLink = "_bi-0";
export var slideUp = "_bi-4";